export default {
	title: 'schedule',
	icon: 'far fa-calendar',
	components: [{ title: 'schedule', component: 'schedule_settings' }],
};
